import { Loader as Action, PRE_LOAD_SERVICES, UPDATE_API_STATUS, CLEAR_REQUEST_LOG } from './constants';

const initialState = {
  loaderStatus: false,
  preLoadServices: [],
  completedRequests: {},
};

function loaderReducer(state = initialState, actions) {
  switch (actions.type) {
    case Action.SHOW_LOADER:
      return { ...state, loaderStatus: true };
    case Action.HIDE_LOADER:
      return { ...state, loaderStatus: false };
    case PRE_LOAD_SERVICES:
      return { ...state, ...actions.payload };
    case UPDATE_API_STATUS:
      return { ...state, completedRequests: { ...state.completedRequests, ...actions.payload } };
    case CLEAR_REQUEST_LOG:
      return { ...state, preLoadServices: [], completedRequests: {} };
    default:
      return state;
  }
}
export default loaderReducer;
